// AI-248 canonicalization: the single source of truth for
// new_location_default_enabled. "Auto-enroll net-new" ⟺ the merchant is at
// 100% coverage (every location would be enabled after Save). Shared by the
// Settings pane and the wizard step so both canonicalize identically.
export const deriveNewLocationDefault = (
  locations: { id: number }[],
  enabledIds: ReadonlySet<number>
): boolean => locations.length > 0 && locations.every(l => enabledIds.has(l.id))
